(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lwg-pet-travel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-pet-gallery] button[data-photo]');
  if(!button)return;
  const gallery=button.closest('[data-pet-gallery]');
  const image=gallery.querySelector('.lwg-pet__image');
  image.removeAttribute('srcset');image.src=button.dataset.photo;image.alt=button.dataset.alt;
  gallery.querySelectorAll('button[data-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  gallery.querySelector('[data-photo-count]').textContent=String(button.dataset.index).padStart(2,'0')+' / 05';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
